<div
  class="info-banner"
  [class.info-banner--warning]="variant() === 'warning'"
  [class.info-banner--compact]="compact()"
  role="note"
  [attr.aria-label]="
    ariaLabel()
      ? translateAriaLabel()
        ? (ariaLabel()! | translate)
        : ariaLabel()
      : null
  "
>
  <div class="info-banner__icon" aria-hidden="true">
    <img [src]="iconUrl()" alt="" />
  </div>
  <div class="info-banner__content">
    @if (title()) {
      <p class="info-banner__title">
        @if (translateTitle()) {
          {{ title()! | translate }}
        } @else {
          {{ title() }}
        }
      </p>
    }
    <p class="info-banner__text">
      @if (translateMessage()) {
        {{ message() | translate }}
      } @else {
        {{ message() }}
      }
    </p>
    @if (actionLabel()) {
      <button
        type="button"
        class="info-banner__action"
        (click)="actionClick.emit()"
      >
        {{ actionLabel() }}
      </button>
    }
  </div>
</div>
